import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { TestBed } from '@angular/core/testing';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { DynamicFormComponent } from 'src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { TenderQuantityService } from 'src/app/Service/tender-quantity/tender-quantity.service';
import { tenderQuantity } from 'src/app/ViewModel/Tender-Quantity.Model';
import { EditConfigurComponent } from '../../tender-add/edit-configur/edit-configur.component';
import { Module } from 'src/app/Service/element-details.data.service';


@Component({
  selector: 'app-project-tender-link',
  templateUrl: './project-tender-link.component.html',
  styleUrls: ['./project-tender-link.component.css']
})
export class ProjectTenderLinkComponent implements OnInit {

  public lastscrollLeft!: number;
  public approverList: any;
  public tenderSection!: boolean;
  public Itemsection!: boolean;
  public Elementsection!: boolean;
  public elementsList!: any[];
  public setclear = 'N';
  public ItemList: any;
  public selectedDiscipline: any;
  public existsTenderElement: any[] = [];
  public currentTab: any;
  public Currentpage: any;
  public ElementProjectlink: any[] = [];
  public ItemProjectlink: any[] = [];
  public sentDataToDp: tenderQuantity[] = [];
  public viewClick!: boolean;
  public subItemlist: any[] = [];
  public structrue: any;
  public tenderlist: any[] = [];
  public quantity:any;
  public submittedby: any = {};
  public docConfig: FieldConfig[] = [];
  public SubmitBtn: boolean = false;
  public ApproveBtn: boolean = false;
  public ReviseBtn: boolean = false;
  public AddBtn: boolean = false;
  public editQuantity!: number;
  public updateQuantity!: number;
  public setDisable: boolean = false;
  public EC_enableFilter :boolean = false;
  public IC_enableFilter :boolean = false;
  public enableFullscreen:any ={'kgrid-fullscreen' : 'enableFullscreen'};
  private editedRowIndex!: any|number;
  private editedLine: any;
  private editEvent: any;

  @ViewChildren('divIcon') divIconHover!: QueryList<any>;
  @ViewChild('docSetForm') tqSetDynamicForm!: DynamicFormComponent;

  constructor(private dialog: MatDialog, private tenderQuantityService: TenderQuantityService,
    public notificationService: NotificationService, private formBuilder: FormBuilder,
    private _projService: ProjectInfoService, private commonService: CommonService) {
  }

  ngOnInit() {
    this.getSelectValue();
    this.getData();
    this.getDynamicFormChanges();
  }

  getDynamicFormChanges() {
    this.tqSetDynamicForm?.form.get('Discipline')?.valueChanges.subscribe(data => {
      this.SubmitBtn = false;
      this.AddBtn = false;
      this.ReviseBtn = false;
      this.ApproveBtn = false;
      this.tenderlist = [];
      if (!!data) {
        this.quantity = null;
        this.selectedDiscipline = data;
        if (this.currentTab == "Tender Quantity") {
          this.setclear = 'Y';
          this.tenderQuantityService.getElementProjectConfigure(this.selectedDiscipline.dedId).subscribe(data => {           
            this.elementsList = data.filter((val: { active_Tag: string; })=>val.active_Tag == "Yes");
            if (!!this.elementsList) {
              this.elementsList.forEach(element => {
                this.tenderQuantityService.getItemProjectConfigure(element).subscribe((data: any[]) => {
                  if (!!data && data.length > 0) {
                    let teId = data[0].tE_Id;
                    let element: any = this.elementsList.filter(x => x.tE_Id == teId)[0];
                    if (!!element) {
                      element.items = data.filter(data => data.disc_DED_Id == this.selectedDiscipline.dedId && data.active_Tag == "Yes");
                    }
                  }
                });
              });
            }
          });
        }
      } else {
        this.selectedDiscipline = undefined;
        this.elementsList = [];
        this.quantity = null;
      }
    });

    this.tqSetDynamicForm?.form.get('Structure / Package')?.valueChanges.subscribe(data => {
      this.SubmitBtn = false;
      this.AddBtn = false;
      this.quantity = null;
      this.ReviseBtn = false;
      this.ApproveBtn = false;
      this.setclear = 'Y';
      this.tenderlist = [];
      this.structrue = data;
    });
  }

  getProjectTenderDetail() {
    let obj = {};
    if (!!this.elementsList) {
      obj = {
        "project_Id": this.commonService.getProjectId(),
        "disc_DED_Id": this.tqSetDynamicForm?.form.get('Discipline')?.value.dedId,
        "t_Id": null
      }
      this.tenderQuantityService.getProjectTenderElement(obj).subscribe(data => {
        this.existsTenderElement = data;
        let structureId = this.tqSetDynamicForm?.form.get('Structure / Package')?.value.dedId
        this.tenderlist = data.filter((value: { struct_DED_Id: any; }) => value.struct_DED_Id == structureId);
      });
    }
  }

  getItemData(data: any, stage: any) {
    let setItem = data.tenderElementDetails.filter((value: { tE_Description: any; }) => value.tE_Description == stage.tE_Description)[0];
    if (!!setItem && !!setItem.tI_Description)
      return setItem.tI_Description;
  }


  tabChanged(event: any) {
    this.AddBtn = false;
    this.SubmitBtn = false;
    this.selectedDiscipline = undefined;
    this.structrue = undefined;
    this.tenderlist = [];
    this.elementsList = [];
    this.quantity = null;
    this.ngOnInit();
    this.currentTab = event.tab.textLabel;
    this.EC_enableFilter = false;
    this.IC_enableFilter  = false;
  }


  getData() {
    this.tenderQuantityService.getElementProjectConfigure().subscribe(data => {
      this.ElementProjectlink = data;
      this.ElementProjectlink.forEach((value,i)=>{
        value["index"]=i+1;
      })
    });

    this.tenderQuantityService.getItemProjectConfigure().subscribe(data => {
      this.ItemProjectlink = data;
      this.ItemProjectlink.forEach((value,i)=>{
        value["index"]=i+1; 
      })
    });

    this._projService.getProjectFeatureWiseMembers({ projectId: this.commonService.getProjectId(), groupId: this.commonService.getLoggedInUserGroupId(), featureDescription: 'Approve' })
      .subscribe((data) => {
        this.approverList = data;
      });
  }



  AddNewData(currentpage?: String, Val?: any) {
    this.Currentpage = currentpage;
    let typeAction:any = {}
    switch (currentpage) {
      case 'Elements-Configure': {
        typeAction["currentpage"] = currentpage
        if (!!Val)
          typeAction["value"] = Val;
        break;
      }
      case 'Item-Configure': {
        typeAction["currentpage"] = currentpage;
        if (!!Val)
          typeAction["value"] = Val;
        break;
      }
      case 'Tender': {
        typeAction["currentpage"] = currentpage;
        if (!!Val)
          typeAction["value"] = Val;
        break;
      }
    }
    let dialogRef = this.dialog.open(EditConfigurComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '70%',
      maxWidth: '70vw',
      data: typeAction
    });
    dialogRef.afterClosed().subscribe(data => {
      this.getData();
    });
  }


  editHandler(currentpage: string, val: any,) {
    this.AddNewData(currentpage, val);
    let test :any= this.tqSetDynamicForm.fields;
    test[0]["setDisable"] = true;
    this.tqSetDynamicForm.createControl();
  }

  getTqSetConfig(): FieldConfig[] {
    return [
      {
        type: 'select',
        name: 'Discipline',
        label: 'Discipline',
        deDescription: 'Discipline',
        module_id: Module.ScheduleDocument,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Please select discipline"
          }
        ],
        value: new BehaviorSubject(null)
      },
      {
        type: 'select',
        name: 'Structure / Package',
        label: 'Structure / Package',
        deDescription: 'Structure / Package',
        module_id: Module.ScheduleDocument,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Structure No Required"
          }
        ],
        value: new BehaviorSubject(null)
      },
    ]
  }

  setRevisionValues(Val?: any) {
    if (Val.value != "-2") {
      this.submittedby['submittedId'] = Val.value;
    }
  }

  getSelectValue() {
    this.docConfig = this.getTqSetConfig();
    this.tqSetDynamicForm.fields = this.docConfig;
    this.tqSetDynamicForm.createControl();
  }

  viewSubBtn() {
    this.setclear = 'Y';
    let getDisciplineChange = this.tqSetDynamicForm?.form.get('Discipline')?.value;
    if (!this.selectedDiscipline) {
      this.notificationService.showPopup("Discipline  Selection is required", "Warning");
      return;
    }

    if (!this.structrue) {
      this.notificationService.showPopup("Structure / Package Selection is required", "Warning");
      return;
    }
    if (this.ApproveBtn == false && this.ReviseBtn == false) {
      this.SubmitBtn = true;
      this.AddBtn = true;
    }
    this.getProjectTenderDetail();
  }

  resetAddControl(valueChanges?: string) {
    this.setclear = 'Y';
    let obj:any = {
      "trans_Type": null,
      "project_Id": this.commonService.getProjectId(),
      "t_Id": null,
      "disc_DED_Id": (!!this.tqSetDynamicForm?.form.get('Discipline')?.value.dedId) ? this.tqSetDynamicForm?.form.get('Discipline')?.value.dedId : "",
      "struct_DED_Id": this.structrue.dedId,
      "active_Tag": "yes",
      "member_Id": this.commonService.getLoggedInUserId(),
      "submitted_Tag": false,
      "submitted_By": null,
      "submitted_On": null,
      "tenderDetails": [],
      "approved_Tag": false,
      "approved_by": null,
      "approved_On": null,
      "sort_By": 0
    }
    obj.trans_Type = "Submit";
    obj.tenderDetails = this.tenderlist.map((element => {
      return { "t_Id": element.t_Id };
    }));

    this.tenderQuantityService.insertTenderData(obj).subscribe(data => {
      if (data.successCode == 200) {
        obj.trans_Type = "Approve";
        obj.tenderDetails = this.tenderlist.map((element => {
          return { "t_Id": element.t_Id };
        }));
        this.tenderQuantityService.insertTenderData(obj).subscribe(data => {
          if (data.successCode == 200) {
            this.getProjectTenderDetail();
          }
        });
      }
    });
    this.SubmitBtn = true;
    this.AddBtn = true;
    this.setDisable = false;
    this.ReviseBtn = false;
  }

  addTender(currentAction?: string) {
    let elementDetails: any[] = this.elementsList.filter(val => !!val.selectedItem).map(data => {
      return { "tE_Id": data.selectedItem.tE_Id, "tI_Id": data.selectedItem.tI_Id }
    });
    let isDuplicate: boolean = false;
    let tenderId: any;
    if (currentAction == 'add') {
      let sortedElements: any[] = elementDetails.sort(a => a.tE_Id);
      for (let itemIndex = 0; itemIndex < this.tenderlist.length; itemIndex++) {
        let currentItem: any = this.tenderlist[itemIndex];
        let items: any[] = currentItem.tenderElementDetails.map((data: { tE_Id: any; tI_Id: any; }) => {
          return { "tE_Id": data.tE_Id, "tI_Id": data.tI_Id }
        }).sort((a: { tE_Id: any; }) => a.tE_Id);
        if (JSON.stringify(sortedElements) === JSON.stringify(items)) {
          this.notificationService.showPopup("Already Exsists!!!", "Warning");
          isDuplicate = true;
          break;
        }
      }
    }

    if (isDuplicate)
      return;

    let obj:any = {
      "trans_Type": null,
      "project_Id": this.commonService.getProjectId(),
      "t_Id": null,
      "disc_DED_Id": (!!this.tqSetDynamicForm?.form.get('Discipline')?.value.dedId) ? this.tqSetDynamicForm?.form.get('Discipline')?.value.dedId : "",
      "struct_DED_Id": this.structrue.dedId,
      "active_Tag": "yes",
      "member_Id": this.commonService.getLoggedInUserId(),
      "submitted_Tag": false,
      "submitted_By": null,
      "submitted_On": null,
      "tenderDetails": [],
      "approved_Tag": false,
      "approved_by": null,
      "approved_On": null,
      "sort_By": 0
    }
    switch (currentAction) {
      case "add": {
        this.setclear = 'N';
        if (elementDetails.length != 0) {
          obj.trans_Type = "Insert";
          obj["quantity"] = this.quantity ? this.quantity : 0;
          this.tenderQuantityService.insertTenderData(obj).subscribe(data => {
            if (data.successCode == 200) {
              tenderId = data.result;
              let addValueTender = { "t_Id": data.result, "tenderElementDetails": elementDetails, active_Tag: "yes", "member_Id": 0 };
              addValueTender.active_Tag = this.elementsList[0].active_Tag;
              addValueTender.member_Id = this.commonService.getLoggedInUserId();
              this.tenderQuantityService.insertElementDetailsTenderData(addValueTender).subscribe(data => {
                if (data.successCode == 200) {
                  this.quantity = null;
                  this.setclear = 'Y';
                  this.getProjectTenderDetail();
                  this.notificationService.showToast(data.successMessage, "Success");
                }
              });
            }
          })
        } else {
          this.notificationService.showPopup("Please Select any one Elements", "Warning");
        }
        break;
      }

      case "submit": {
        this.quantity = null;
        obj.trans_Type = "Submit";
        obj.submitted_Tag = true;
        obj.submitted_By = this.commonService.getLoggedInUserId();
        obj.submitted_On = new Date();
        obj.tenderDetails = this.tenderlist.map((element => {
          return { "t_Id": element.t_Id };
        }));
        this.tenderQuantityService.insertTenderData(obj).subscribe(data => {
          if (data.successCode == 200) {
            if (!!this.editEvent) {
              this.closeEditor(this.editEvent);
            }
            this.SubmitBtn = false;
            this.AddBtn = false;
            this.ApproveBtn = true;
            this.getProjectTenderDetail();

            this.notificationService.showToast(data.successMessage, "Success");
          }
        });
        break;
      } case "approve": {
        if (!!this.submittedby.submittedId) {
          obj.trans_Type = "Approve";
          obj.approved_Tag = true;
          obj.approved_by = this.submittedby.submittedId;
          obj.approved_On = new Date();
          obj.tenderDetails = this.tenderlist.map((element => {
            return { "t_Id": element.t_Id };
          }));
          this.tenderQuantityService.insertTenderData(obj).subscribe(data => {
            if (data.successCode == 200) {
              this.setclear = 'Y';
              this.SubmitBtn = false;
              this.AddBtn = false;
              this.ApproveBtn = false;
              this.ReviseBtn = true;
              this.getProjectTenderDetail();
              this.notificationService.showToast(data.successMessage, "Success");
            }
          });
        } else {
          this.notificationService.showPopup("Please Select Approved By", "Warning");
        }
        break;
      }
    }
  }

  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } else {
      if (this.quantity > 8000000) {
        return false;
      }
      return true;
    }
  }

  onValueChange(value: any, element: any) {
    if (!!value && value.value != "-2") {
      element.selectedItem = value.additionalValues.additionalValues;
    }
    else {
      element.selectedItem = null;
    }
  }

  

  editRowData(data:any) {
    this.editEvent = data.sender;
    this.closeEditor(data.sender);
    this.editedRowIndex = data.rowIndex;
    this.editedLine = Object.assign({}, data.dataItem);
    data.sender.editRow(data.rowIndex);
    this.updateQuantity = data.dataItem.tenderElementDetails[0].quantity;
  }

  closeEditor(grid: { closeRow: (arg0: number) => void; }, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.editedLine = undefined;
  }

  cancelHandler(data:any) {
    this.closeEditor(data.sender, data.rowIndex);
  }

  deleteRowData(data:any){   
    this.tenderQuantityService.deleteTender(data.dataItem.t_Id).subscribe(data =>{  
      if (data.successCode == 200) {  
      this.getProjectTenderDetail();
      this.notificationService.showToast(data.successMessage, "Success");
     }
    });
  }
  
  UpdateRowData(data:any) {
    let obj:any = {
      "trans_Type": "Insert",
      "t_Id": data.dataItem.t_Id,
      "project_Id": this.commonService.getProjectId(),
      "member_Id": this.commonService.getLoggedInUserId(),
      "disc_DED_Id": data.dataItem.disc_DED_Id,
      "struct_DED_Id": data.dataItem.struct_DED_Id,
      "active_Tag": "yes",
      "quantity": this.updateQuantity,
      "submitted_Tag": false,
      "submitted_By": null,
      "submitted_On": null,
      "tenderDetails": [],
      "approved_Tag": false,
      "approved_by": null,
      "approved_On": null,
      "sort_By": 0
    }
    this.tenderQuantityService.insertTenderData(obj).subscribe(data => {
      if (data.successCode == 200) {
        this.closeEditor(data.sender);
        this.getProjectTenderDetail();
        this.notificationService.showToast(data.successMessage, "Success");
      }
    });
  }

  toggleFilter(tap:any) {   
    switch (tap){
      case 'element' :{   
        this.EC_enableFilter = !this.EC_enableFilter;
        break;
      }
      case 'items' :{     
        this.IC_enableFilter  = !this.IC_enableFilter;
        break;
      }     
    }   
  }
 
}


